// extracted by mini-css-extract-plugin
export default {"card":"B7-z"};